<template>
    <div class="body-panel dataContent">
        <template v-if="material != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back">
                            <router-link :to="'/materials/' + $route.params.materialId">Назад к материалу</router-link>
                        </p>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page" id="playerContainer">
                <div class="mob-flex-to-block height-full mob-height-auto material-conteiner">
                    <div class="material-body">
                        <div class="material-body-content">
                                <h2 class="margin-bottom-20">{{ currentMaterialFile.Name }}</h2>

                                <video-viewer ref="videoView" v-if="material != null" :title="material.Name" @onPageChanged="onPageChanged"></video-viewer>

                                <pdf-viewer ref="pdfView" v-if="material != null" :title="material.Name" @onPageChanged="onPageChanged"></pdf-viewer>

                                <presentation-viewer ref="presentationView" v-if="material != null" :title="material.Name" @onPageChanged="onPageChanged"></presentation-viewer>

                                <scorm-viewer ref="scormView" v-if="material != null" :title="material.Name" @onPageChanged="onPageChanged"></scorm-viewer>

                                <div v-if="isMobile && materialFilePath" class="margin-top-5">
                                    <a :href="materialFilePath" target="_blank" download>Скачать</a>
                                </div>
                        </div>
                    </div>

                </div>
            </div>

        </template>



        <vue-headful title="Материалы" />
    </div>
</template>


<script>
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import config from '../../config'

    let backendApi = new BackendApi();

    let iFrame;

    export default {
        name: "materialfile-details",

        props: ['info'],

        data() {
            return {
                material: null,
                currentMaterialFile: null,
                isMobile: UI.check_mobile()
            }
        },

        computed:{
            materialFilePath(){
                if(this.currentMaterialFile.ActiveContentType === 3 || this.currentMaterialFile.ActiveContentType === 4) {
                    return 'https://storage.yandexcloud.net/' + config.yandexCloudBucketName + '/' + this.currentMaterialFile.ContentFileName;
                }
                return null;
            }
        },

        methods: {

            onViewMaterialFile(materialFile) {


                this.currentMaterialFile = materialFile;
                let page = materialFile.ProgressPage;
                //console.info('onViewMaterialFile, page', page)
                if(page == null){
                    page = materialFile.ActiveContentType === 3 ? 1 : 0;
                }
                this.onContinueViewing(page);
            },

            onPageChanged(page, duration){
                //console.info('onPageChanged:', page);
                this.updateProgress(page, duration);
            },

            updateProgress(page, duration){
                let vm = this;
                if(vm.currentMaterialFile == null)
                {
                    console.info('currentMaterialFile is null');
                    return;
                }
                this.callApiWrapper(backendApi.materialUpdateProgress(vm.currentMaterialFile.Id, page, duration))
                    .then(function (resp) {
                        if (!resp.hasError) {
                            if(resp.data.ProgressPercent === 1){
                                vm.currentMaterialFile.ProgressStatus = 'Завершён';
                            }
                            else{
                                vm.currentMaterialFile.ProgressStatus = `Изучено ${(resp.data.ProgressPercent*100).toFixed(0)}%`;
                            }
                            vm.currentMaterialFile.ProgressPage = resp.data.ProgressPage;
                            vm.currentMaterialFile.ProgressPercent = resp.data.ProgressPercent;

                            // if(resp.data.ProgressPercent === 1) {
                            //     for (let i = 0; i < vm.material.Files.length; i++) {
                            //         if (!vm.material.FilesOrderLocked || i === 0 || vm.material.Files[i - 1].ProgressPercent == 1) {
                            //             vm.material.Files[i].Available = true;
                            //         }
                            //     }
                            // }
                        }
                    });
            },

            onContinueViewing(page) {
                let vm = this;
                let materialFile = this.currentMaterialFile;

                this.$nextTick(() => {
                    if (materialFile.ActiveContentType === 4) {
                        vm.$refs['videoView'].show(materialFile.ContentFileName, page, materialFile.ProgressPage);

                    } else if (materialFile.ActiveContentType === 3) {
                        vm.$refs['pdfView'].show(materialFile.ContentFileName, page, materialFile.ProgressPage);
                    } else if (materialFile.ActiveContentType === 2) {
                        vm.$refs['videoView'].show(materialFile.ContentFileName, page, materialFile.ProgressPercent, true);
                    }
                    else if (materialFile.ActiveContentType === 1) {
                        vm.$refs['presentationView'].show(config.apiUrl + '/Home/Player?materialId=' + vm.material.Id + '&page=' + page);
                    }
                    else if (materialFile.ActiveContentType === 5) {
                        vm.$refs['scormView'].show(`/uploads/materials/${vm.material.ProjectId}/${vm.material.Id}/${materialFile.Id}/${materialFile.ScormStartPath}`,
                            materialFile.ScormStubFileName);
                    }
                });
            },

            loadMaterial() {
                let vm = this;
                let id = parseInt(this.$route.params.materialId);
                let materialFileId = parseInt(this.$route.params.id);

                return this.callApiWrapper(backendApi.materialLoad(id)).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке материала');
                    }
                    else {
                        if (response.data == null) {
                            vm.$router.push('/materials');
                        }
                        else {

                            let materialFile = response.data.Files.find(x => x.Id === materialFileId);

                            let page = materialFile.ProgressPage;
                            if(page == null || materialFile.ProgressPercent === 1){
                                page = materialFile.ActiveContentType === 3 ? 1 : 0;
                            }

                            vm.material = response.data;
                            vm.currentMaterialFile = materialFile;

                            vm.onContinueViewing(page);
                        }
                    }
                })
            }
        },

        mounted() {
            let vm = this;

            UI.blockUI('.dataContent', 'Загрузка...');
            Promise.all([this.loadMaterial()]).then(() => {
                UI.unblockUI('.dataContent');

                vm.$nextTick(() => {

                    if (vm.material.ActiveContentType === 1 && (vm.material.Status === 2 || (vm.info.User.MainRole === 'administrators'))) {

                        let materialId = parseInt(vm.$route.params.id);
                        let playerContainer = document.getElementById('playContent');

                        if (playerContainer != null) {
                            iFrame = document.createElement('iframe');
                            iFrame.src = config.apiUrl + '/Home/Player?materialId=' + materialId;
                            let div = document.createElement('div');
                            div.className = "scroll_frame";
                            div.appendChild(iFrame);
                            playerContainer.appendChild(div);
                        }
                    }

                });
            });
        },

        destroyed() {
            if (iFrame != null) {
                iFrame.parentNode.removeChild(iFrame);
            }
        }

    }
</script>

<style>
    .course-content{
        height: calc(100% - 40px);
    }

</style>


// WEBPACK FOOTER //
// Content/src/views/details/MaterialFileDetails.vue